import React from 'react';
import '../styles/LoadingIndicator.css'; // Make sure to create this file

const LoadingIndicator = ({ text = "Processing..." }) => {
  return (
    <div className="preload-overlay">
      <div className="spinner"></div>
      <p>{text}</p>
    </div>
  );
};

export default LoadingIndicator;